<template>
    <form-item label-width="80" labelAlign="left" label="字段名">
        {{ item.aliasName || item.name }}
    </form-item>
    <form-item label-width="80" labelAlign="left" label="字段别名">
        {{ item.name }}
    </form-item>
    <form-item label-width="80" labelAlign="left" label="字段编码">
        {{ item.code }}
    </form-item>
    <form-item v-if="item.formula" label-width="80" labelAlign="left" label="公式配置">
        <!-- {{ item.code }} -->
        <div v-for="formItem in item.formula.formulaData" :key="formItem">{{ formItem.value }}</div>
        <el-icon size="15" style="margin-left: 10px">
            <Edit @click="handleEditFormula"></Edit>
        </el-icon>
        <CusMetrics
            v-model="showCusMetrics"
            @confirm="confirmEditFormula"
            :option="option"
            :initData="initData"
            v-if="showCusMetrics"
        ></CusMetrics>
    </form-item>
</template>
<script setup>
import CusMetrics from '@/option/components/dataCenter/cusMetrics.vue';
import { Edit } from "@element-plus/icons-vue";

let props = defineProps({
    temData: {},
    item: {},
    option: {}
});
const initData = ref({});

let showCusMetrics = ref(false);
const handleEditFormula = () => {
    // props.item.formula.formulaData[0] = {
    //     type: 3,
    //     value: '2+'
    // };
    initData.value = props.item.formula.formulaData;
    showCusMetrics.value = true;
};
const confirmEditFormula = e => {
    props.item.formula = e;
};
</script>

<style scoped lang="scss"></style>
